import React, { Children } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: auto;
  padding: 0.5rem 0;
  font-size: 0.9rem;
  align-items: center;
  justify-content: flex-start;
`

const Separator = styled.div`
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  width: 1.5rem;
  opacity: 0.5;
  color: ${(props) => props.theme.colours.text.tertiary};
`

const Breadcrumbs = ({ children }) => {
  // TODO: Wrap each child, insert separators
  return (
    <Container>
      {Children.map(children, (child, idx) => (
        <>
          {idx > 0 && (
            <Separator>
              <FontAwesomeIcon icon={faChevronRight} />
            </Separator>
          )}
          {child}
        </>
      ))}
    </Container>
  )
}

Breadcrumbs.propTypes = {
  children: PropTypes.any,
}

export default Breadcrumbs
